import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_app/oncology/")({
  // /oncology has no landing page of its own — send to the triage queue.
  beforeLoad: () => {
    throw redirect({ to: "/oncology/triage" })
  },
})
